import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";

const MasterReceipt = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [receipts, setReceipts] = useState([]);
  const [columns, setColumns] = useState([]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    fetchReceipts();
  }, []);

const fetchReceipts = async () => {
  try {
    const societyName = localStorage.getItem("society");
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${BASE_URL}/bill-master/get-master-receipt`,
      null, // ✅ no body needed (since you're using @RequestParam)
      {
        params: { societyName }, // ✅ correct place
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data || [];
    setReceipts(data);

    if (data.length > 0) {
      setColumns(Object.keys(data[0]));
    }

    console.log("Receipts:", data);
  } catch (error) {
    console.error("Error fetching receipts:", error);
  }
};

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />

          {/* <h2>Master Receipt Page</h2> */}

          {/* ================= DYNAMIC TABLE ================= */}
          <div style={{ overflowX: "auto", marginTop: "20px" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: "600px",
              }}
            >
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col}
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        background: "#2563eb",
                        color: "white",
                        textTransform: "capitalize",
                      }}
                    >
                      {col.replace(/_/g, " ")}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {receipts.map((row, index) => (
                  <tr key={index}>
                    {columns.map((col) => (
                      <td
                        key={col}
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                        }}
                      >
                        {row[col] ?? "-"}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MasterReceipt;